module.exports = __webpack_public_path__ + "assets/img/folder-icon-disabled.fc31f96a.svg";